<span class="ant-table-column-title"><ng-template [ngTemplateOutlet]="contentTemplate"></ng-template></span>
<span class="ant-table-column-sorter" [class.ant-table-column-sorter-full]="isDown && isUp">
  <span class="ant-table-column-sorter-inner">
    <ui-icon uiType="caret-up" *ngIf="isUp" class="ant-table-column-sorter-up" [class.active]="sortOrder === 'ascend'"></ui-icon>
    <ui-icon uiType="caret-down" *ngIf="isDown" class="ant-table-column-sorter-down" [class.active]="sortOrder === 'descend'"></ui-icon>>
  </span>
</span>
